import disasterRecoveryImg from "public/iaas/disaster_recovery.png";

export const OEM_SOLUTIONS_CONSTANTS = {
  title: "OEM Converged Architecture Solutions",
  desc: "OEM Converged Architecture is widely used in industries such as telecommunications, finance, healthcare, and manufacturing to optimize IT infrastructure. These solutions enable seamless integration, enhanced performance, and scalability.",
  list: [
    {
      image: disasterRecoveryImg,
      title: "Converged Plantwide Ethernet (CPwE)",
      content:
        "Enables seamless integration of OEM devices into an industrial network, ensuring high-performance connectivity and security.",
    },
    {
      image: disasterRecoveryImg,
      title: "Hybrid Cloud Deployment",
      content:
        "Combines on-premises and cloud resources to optimize workloads, reduce costs, and improve flexibility.",
    },
    {
      image: disasterRecoveryImg,
      title: "Edge Computing Integration",
      content:
        "Supports real-time data processing and analytics at the network edge, enhancing AI, IoT, and automation capabilities.",
    },
    {
      image: disasterRecoveryImg,
      title: "Multi-Vendor Compatibility",
      content:
        "OEM architecture is designed to work across different hardware vendors, networking providers, and cloud services, ensuring interoperability and scalability.",
    },
  ],
};
